import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=465ca0bb&scoped=true&"
import script from "./step4.vue?vue&type=script&lang=ts&"
export * from "./step4.vue?vue&type=script&lang=ts&"
import style0 from "./step4.vue?vue&type=style&index=0&id=465ca0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ca0bb",
  null
  
)

export default component.exports